/// <loc filename=""/>

(function () {

    window.modalAlert = function (options) {
        ///<signature>
        ///<summary>
        /// Creates a modal alert using these possible options.
        /// - header: String value to display in the header. or true to display an empty header. false will not display a header. true is the default.
        /// - message: String value to display in the body of the alert.
        /// - width: Int custom width for the alert.
        /// - height: Int custom height for the alert.
        /// - close: function to be called after the alert is closed.
        /// - buttons: Array of objects defining the buttons in the alert. each button click causes the alert to be destroyed.
        ///     - [].name: String value to display on the button.
        ///     - [].click: function to be called when this button is clicked.
        ///     - [].class: class name to add to the button.
        /// </summary>
        ///<param name="options" type="Object">
        /// Object containing properties that define the alert.
        ///</param>
        ///</signature>
        
        return createModalAlert(options);
    }

    function createModalAlert(options) {
        if (!options) {
            options = {};
        }
        else if (typeof options === "string"){
            options = {header: true, message: options};
        }

        var modal = $("<div>");
        modal.addClass("fp-modal");

        var mask = $("<div>");
        mask.addClass("fp-modal-mask");
        modal.append(mask);

        var modalAlert = $("<div>");
        modalAlert.addClass("fp-modal-alert");

        if (options.width) {
            var width = typeof options.width == "number" ? options.width + "px" : options.width;
            modalAlert.css("width", width);
        }

        //if (options.header && (typeof options.header != "boolean" || options.header == true)) {
        if (options.header != false) {
            var modalHeader = $("<div>");
            modalHeader.addClass("fp-modal-header");
            if (typeof options.header == "boolean") {
                modalHeader.css("height", "20px");
            } else {
                modalHeader.append(options.header);
            }
            
            modalAlert.append(modalHeader);
        }

        var modalContent = $("<div>");
        modalContent.addClass("fp-modal-content");

        if (options.height) {
            var height = typeof options.height == "number" ? options.height + "px" : options.height;
            modalContent.css("height", height);
        }

        if (options.message) {
            var message = $("<p>");
            message.addClass("fp-modal-alert-message");

            if (options.justify === "none") {
                message.css("text-align", "initial");
            }
            else if (options.justify === "left") {
                message.css("text-align", "left");
            }
            else if (options.justify === "right") {
                message.css("text-align", "right");
            }
            else if (options.justify === "center") {
                message.css("text-align", "center");
            }

            if (options.spaces === "break") {
                message.css("white-space", "break-spaces");
            }
            else if (options.spaces === "pre") {
                message.css("white-space", "pre");
            }

            message.html(options.message);
            modalContent.append(message);
        }

        function onClose() {
            modal.fadeOut('fast', function() { modal.remove(); });
            if (options.close && typeof options.close == "function") {
                options.close();
            }
        }

        var buttons = $("<div>");
        buttons.addClass("fp-modal-alert-buttons");
        if (options.buttons && options.buttons.length > 0) {
            $.each(options.buttons, function(index, info) {
                var name = info.name && typeof info.name == "string" ? info.name : "";
                var button = $("<input>");
                button.attr("type", "button");
                button.attr("value", name);
                if (info.class) {
                    button.addClass(info.class);
                }
                if (info.title) {
                    button.attr("title", info.title);
                }
                button.click(function() {
                    if (info.click && typeof info.click == "function") {
                        info.click();
                    }
                    onClose();
                });
                buttons.append(button);
            });
        } else {
            var okButton = $("<input>");
            okButton.attr("type", "button");
            okButton.attr("value", "OK");
            okButton.click(function() {
                onClose();
            });
            buttons.append(okButton);
        }
        modalContent.append(buttons);

        modalAlert.append(modalContent);

        modal.append(modalAlert);

        $("body").append(modal);

        if(!options.open) options.open = function() {
            $(this).find(":input:visible:first").focus();
        }

        modal.fadeIn('fast', options.open);

        return modalAlert;
    }

    $.fn.modalForm = function () {
        ///<signature>
        ///<summary>turns a container into a modal</summary>
        ///<param name="header">string value to display as the Header for the modal</param>
        ///<returns type="object">
        /// an object continaing properties and methods that can be used after the modal is created.
        /// $el: the jquery element for the modal,
        /// onshow: a function that will be called immediately after the modal show method is called,
        /// onhide: a function that will be called immediately before the modal hide method is called,
        /// show: the official method to make the modal visible,
        /// hide: the official method to make the modal invisible,
        /// toggle: toggles between the show and hide methods
        /// </returns>
        ///</signature>
        ///<signature>
        ///<summary>turns a container into a modal</summary>
        ///<param name="options">
        /// an object containing options for the modal.
        /// current options include:
        /// header: string value to display as the Header for the modal,
        /// show: a function that will be called immediately after the modal show method is called,
        /// onshow: an alternative to setting show,
        /// hide: a function that will be called immediately before the modal hide method is called,
        /// onhide: an alternative to setting hide
        ///</param>
        ///<returns type="object">
        /// an object continaing properties and methods that can be used after the modal is created.
        /// $el: the jquery element for the modal,
        /// content: the content element for the modal,
        /// onshow: a function that will be called immediately after the modal show method is called,
        /// onhide: a function that will be called immediately before the modal hide method is called,
        /// show: the official method to make the modal visible,
        /// hide: the official method to make the modal invisible,
        /// toggle: toggles between the show and hide methods
        /// </returns>
        ///</signature>

        var $root = $(this);
        var root = this;
        var header = $root.attr("data-fp-modal-header") || "";
        var onshow = undefined;
        var onhide = undefined;
        var loadUrl = $root.attr("data-fp-load-url");
        var alwaysRefresh = $root.attr("data-fp-always-refresh") || false;
        var prerender = $root.attr("data-fp-pre-render");
        var onrender = $root.attr("data-fp-onrender");
        

        if (arguments.length > 0) {
            if (typeof arguments[0] == "string") {
                header = arguments[0];
            } else if (typeof arguments[0] == "object") {
                var obj = arguments[0];
                if (obj["header"] && typeof obj["header"] == "string") {
                    header = obj["header"];
                }

                if (obj["show"] && typeof obj["show"] == "function") {
                    onshow = obj["show"];
                } else if (obj["onshow"] && typeof obj["onshow"] == "function") {
                    onshow = obj["onshow"];
                }

                if (obj["hide"] && typeof obj["hide"] == "function") {
                    onhide = obj["hide"];
                } else if (obj["onhide"] && typeof obj["onhide"] == "function") {
                    onhide = obj["onhide"];
                }

                if (obj["loadUrl"]) loadUrl = obj["loadUrl"];

                if (obj["alwaysRefresh"]) alwaysRefresh = obj["alwaysRefresh"];

                if (obj["prerender"]) prerender = obj["prerender"];

                if (obj["onrender"]) onrender = obj["onrender"];
            }
        }

        var isRendered = loadUrl == undefined;

        var response = {
            $el: $root,
            content: $root.find(".fp-modal-content"),
            header: function(value) {
                if (arguments.length === 0) return $root.find(".fp-modal-header .header").text();
                else return $root.find(".fp-modal-header .header").text(value);
            },
            $: function(selector) {
                return $root.find(selector);
            },
            onshow: onshow,
            onhide: onhide,
            show: function() {
                $root.show();
                if (isRendered) {
                    if (this.onshow) {
                        this.onshow.call(root);
                    }
                } else {
                    draw();
                }
                $root.trigger("show");
            },
            hide: function() {
                if (this.onhide) {
                    this.onhide.call(root);
                }
                $root.hide();
                $root.trigger("hide");
            },
            toggle: function() {
                if ($root.prop("visible")) {
                    this.hide();
                    return false;
                } else {
                    this.show();
                    return true;
                }
            },
            redraw: function() {
                if ($root.prop("visible")) {
                    draw();
                } else {
                    isRendered = false;
                }
            }
        };
        createModalForm.call(this, header, response);

        function draw() {
            if (prerender) prerender.call(root);
            $.ajax({
                url: loadUrl,
                cache: false,
                success: function (result) {
                    $root.find(".fp-modal-content").html(result);
                    if (onrender) {
                        if (typeof onrender == "string" && window[onrender]) window[onrender].call(root);
                        else if (typeof onrender == "function") onrender.call(root);
                    }

                    if (onshow) {
                        onshow.call(root);
                    }
                    isRendered = !alwaysRefresh;
                }
            });
        }

        return response;
    }

    function createModalForm(header, response) {
        var modalContent = $("<div>");
        modalContent.addClass("fp-modal-content");
        $(this).wrapInner(modalContent);

        var modalHeader = $("<div>");
        modalHeader.addClass("fp-modal-header");
        modalHeader.append("<span class=header>" + header + "</span>");
        var close = $("<span>");
        close.addClass("fp-modal-button close-modal");
        close.append("X");
        close.click(function () {
            //$(this).closest(".fp-modal").hide();
            response.hide();
        });
        modalHeader.append(close);
        $(this).prepend(modalHeader);

        var modalForm = $("<div>");
        modalForm.addClass("fp-modal-form");
        $(this).wrapInner(modalForm);

        var mask = $("<div>");
        mask.addClass("fp-modal-mask");
        mask.click(function () {
            //$(this).closest(".fp-modal").hide();
            response.hide();
        });
        $(this).prepend(mask);

        $(this).addClass("fp-modal");
        response.content = $(this).find(".fp-modal-content");
    }
})();